import { computed, isRef } from "vue";
import { useI18n } from "vue-i18n";

export const PropertyType = Object.freeze({
    BRAND: "brand",
    SUPPLIER: "supplier",
    SERIAL_NUMBER: "serial_number",
    CATEGORY: "category",
    PURCHASE_DATE: "purchased_at",
    COMMENT: "comment",
    SPACE: "space",
    ASSET_GROUP: "group",
    TASKS: "tasks",
    FILES: "files",
    ASSETS: "assets",
    QR_CODES: "qr_codes",
});

export function useProperties(storeKey, object) {
    const _storeKey = computed(() =>
        isRef(storeKey) ? storeKey.value : storeKey
    );

    const _object = computed(() => (isRef(object) ? object.value : object));

    const { t } = useI18n();

    const allProperties = Object.freeze({
        [PropertyType.BRAND]: {
            key: PropertyType.BRAND,
            type: "input",
            icon: "flag",
            label: t("components.properties.brand"),
        },
        [PropertyType.SUPPLIER]: {
            key: PropertyType.SUPPLIER,
            type: "input",
            icon: "suitcase",
            label: t("components.properties.supplier"),
        },
        [PropertyType.SERIAL_NUMBER]: {
            key: PropertyType.SERIAL_NUMBER,
            type: "input",
            icon: "key",
            label: t("components.properties.serial_number"),
        },
        [PropertyType.CATEGORY]: {
            key: PropertyType.CATEGORY,
            type: "category",
            icon: "hashtag-square",
            label: t("components.properties.category"),
        },
        [PropertyType.PURCHASE_DATE]: {
            key: PropertyType.PURCHASE_DATE,
            type: "datepicker",
            icon: "calendar-default",
            label: t("components.properties.purchased_at"),
        },
        [PropertyType.COMMENT]: {
            key: PropertyType.COMMENT,
            type: "input",
            icon: "document",
            label: t("components.properties.comment"),
        },
    });

    const properties = computed(() => {
        switch (_storeKey.value) {
            case "assets":
                return [
                    {
                        ...allProperties[PropertyType.BRAND],
                        value: _object.value.brand,
                    },
                    {
                        ...allProperties[PropertyType.SUPPLIER],
                        value: _object.value.supplier,
                    },
                    {
                        ...allProperties[PropertyType.SERIAL_NUMBER],
                        value: _object.value.serial_number,
                    },
                    {
                        ...allProperties[PropertyType.CATEGORY],
                        value: _object.value.category,
                    },
                    {
                        ...allProperties[PropertyType.PURCHASE_DATE],
                        value: _object.value.purchased_at,
                    },
                    {
                        ...allProperties[PropertyType.COMMENT],
                        value: _object.value.comment,
                    },
                ];
            default:
                return [];
        }
    });

    return {
        properties,
    };
}
